<div id="maindiv" class="print-container">
  <div class="partner-title">{{ partnerData.Name }}</div>
  <div *ngIf="jobcard && cyclist && bike">
    <div class="padding">
      <div>
        <b>{{ 'general.jobcard_no' | translate }}:</b> {{ jobcard.JobCardNo }}
      </div>
      <div *ngIf="partnerData.ShowJobCardStatus && jobcard && jobcard.StatusID">
        <b>{{ 'general.status' | translate }}:</b> {{ getStatusDescription() }}
      </div>
      <div>
        <b>{{ 'bikeshop.print.service_type' | translate }}:</b>
        {{ serviceTypes }}
      </div>
      <div>
        <b>{{ 'bikeshop.print.scheduled_date' | translate }}:</b>
        {{ jobcard.DateCheckedIn | DateFormatPipe: displayDateTimeFormat }}
      </div>
      <div *ngIf="jobcard.DateRequiredBy">
        <b>{{ 'general.required_by' | translate }}:</b>
        {{ jobcard.DateRequiredBy | DateFormatPipe: displayDateTimeFormat }}
      </div>
    </div>
    <div class="block">
      <div class="block-title">
        {{ 'bikeshop.print.customer_details' | translate }}
      </div>
      <div class="block-content">
        <div>
          <b>{{ 'general.name' | translate }}:</b> {{ cyclist.Name }}
          {{ cyclist.Surname }}
        </div>
        <div>
          <b>{{ 'general.email' | translate }}:</b> {{ cyclist.Email }}
        </div>
        <div>
          <b>{{ 'general.phone_number' | translate }}:</b>
          {{ cyclist.PhoneNumber }}
        </div>
      </div>
    </div>
    <div class="block">
      <div class="block-title">
        {{ 'bikeshop.print.bike_details' | translate }}
      </div>
      <div class="block-content">
        <div>
          <b>{{ 'general.manufacturer' | translate }}:</b>
          {{ bike.Manufacturer }}
        </div>
        <div>
          <b>{{ 'general.model' | translate }}:</b> {{ bike.Model }}
        </div>
        <div>
          <b>{{ 'general.color' | translate }}:</b> {{ bike.Colour }}
        </div>
        <div>
          <b>{{ 'bikeshop.modal.shared.bike.serial_no' | translate }}:</b> {{ bike.SerialNo }}
        </div>
      </div>
    </div>
    <div class="block">
      <div class="block-title">
        {{ 'bikeshop.print.customer_notes' | translate }}
      </div>
      <div class="block-content">
        <div [innerHTML]="jobcard.Client_Notes ? jobcard.Client_Notes : '-'"></div>
      </div>
    </div>
    <div class="block">
      <div class="block-title">
        {{ 'bikeshop.print.assessment_notes' | translate }}
      </div>
      <div class="block-content">
        <div [innerHTML]="jobcard.InitialAssesment_Notes ? jobcard.InitialAssesment_Notes : '-'"></div>
      </div>
    </div>
    <div class="block" *ngIf="jobcard.Technician_Notes">
      <div class="block-title">
        {{ 'bikeshop.print.technician_notes' | translate }}
      </div>
      <div class="block-content">
        <div innerHTML="{{jobcard.Technician_Notes ? jobcard.Technician_Notes: '-'}}">
        </div>
      </div>
    </div>
    <div class="block" *ngIf="checklist && checklist.length > 0">
      <div class="block-title">
        {{ 'bikeshop.print.checklist_items_for_this_job' | translate }}
      </div>
      <div class="block-content">
        <div *ngFor="let item of checklist" class="flex underline">
          <span>{{ item.description }}</span>
          <div *ngIf="item.controlType==='CHECKBOX'" class="check-value">
            <span *ngIf="!item.frontRearCheck">
              <span class="fa"
                    [ngClass]="{ 'fa-check-square-o' : item.defaultValue, 'fa-square-o' : !item.defaultValue || item.defaultValue ==='false' }"></span>
            </span>
            <span *ngIf="item.frontRearCheck">
              <b>F</b><span class="fa"
                            [ngClass]="{ 'fa-check-square-o' : item.frontValue, 'fa-square-o' : !item.frontValue || item.frontValue ==='false' }"></span>
            </span>
            <span *ngIf="item.frontRearCheck">
              <b>R</b><span class="fa"
                            [ngClass]="{ 'fa-check-square-o' : item.rearValue, 'fa-square-o' : !item.rearValue || item.rearValue ==='false' }"></span>
            </span>
          </div>
          <div *ngIf="item.controlType==='TEXT' || item.controlType==='RADIO' || item.controlType==='MULTILINETEXT'"
               class="text-value">
            <span *ngIf="!item.frontRearCheck && item.defaultValue"><span>{{item.defaultValue}}</span></span>
            <span *ngIf="item.frontRearCheck && item.frontValue"><b>F:</b> {{item.frontValue}}</span>
            <span *ngIf="item.frontRearCheck && item.rearValue"><b>R:</b> {{item.rearValue}}</span>
          </div>
          <div *ngIf="item.controlType==='TRAFFICLIGHT'" class="text-value">
            <div class="radio-group" style="display: flex; gap: 6px;">
              <span class="fa" style="color: red; padding-top: 2%;"        [ngClass]="{ 'fa-check-square-o' : item.defaultValue ==='Yes',             'fa-square-o' : !item.defaultValue || item.defaultValue !=='Yes' }"></span>
              <span class="fa" style="color: darkorange; padding-top: 2%;" [ngClass]="{ 'fa-check-square-o' : item.defaultValue ==='No',              'fa-square-o' : !item.defaultValue || item.defaultValue !=='No' }"></span>
              <span class="fa" style="color: green; padding-top: 2%;"      [ngClass]="{ 'fa-check-square-o' : item.defaultValue ==='Not applicable',  'fa-square-o' : !item.defaultValue || item.defaultValue !=='Not applicable' }"></span>
              <span style="width:256px" *ngIf="!item.frontRearCheck && item.frontValue"><b></b> {{item.frontValue}}</span>
              <span style="width:125px" *ngIf="item.frontRearCheck && item.frontValue"><b>F:</b> {{item.frontValue}}</span>
              <span style="width:125px" *ngIf="item.frontRearCheck && item.rearValue"><b>R:</b> {{item.rearValue}}</span>
            </div>
            
          </div>
        </div>
      </div>
    </div>

    <div class="block" *ngIf="partnerData.Print_ShowQuote && quote && quote.LineItems && quote.LineItems.length > 0">
      <div class="block-title">{{ 'bikeshop.print.item' | translate }}</div>
      <div class="block-content">
        <div class="li-row li-row--header">
          <div class="li-col-name bold">{{ 'bikeshop.print.item' | translate }}</div>
          <div class="li-col-qty bold right">#</div>
          <div class="li-col-price bold right">{{ 'bikeshop.print.price' | translate }}</div>
        </div>
        <ng-container *ngIf="labourItems.length > 0">
          <div class="li-group-header">{{ 'bikeshop.workshop.jobcard.labour' | translate }}</div>
          <div class="li-row" *ngFor="let lineItem of labourItems">
            <div class="li-col-name">{{ lineItem.Name }}</div>
            <div class="li-col-qty right">{{ lineItem.Quantity }}</div>
            <div class="li-col-price right">{{quote.CurrencySymbol}}{{ partnerData.VATInclusive ? lineItem.UnitPrice_IncludingTax : lineItem.Price | number : '.2-2' }}</div>
          </div>
        </ng-container>
        <ng-container *ngIf="partsItems.length > 0">
          <div class="li-group-header">{{ 'bikeshop.workshop.jobcard.parts_and_materials' | translate }}</div>
          <div class="li-row" *ngFor="let lineItem of partsItems">
            <div class="li-col-name">{{ lineItem.Name }}</div>
            <div class="li-col-qty right">{{ lineItem.Quantity }}</div>
            <div class="li-col-price right">{{quote.CurrencySymbol}}{{ partnerData.VATInclusive ? lineItem.UnitPrice_IncludingTax : lineItem.Price | number : '.2-2' }}</div>
          </div>
        </ng-container>
        <div class="li-row li-row--total">
          <div class="li-col-name"></div>
          <div class="li-col-qty right bold">{{ 'bikeshop.print.total' | translate }}:</div>
          <div class="li-col-price right bold">{{quote.CurrencySymbol}}{{ quote.Total_Price | number : '.2-2' }}</div>
        </div>
      </div>
    </div>

    <div class="block">
      <div class="block-title">
        <div class="cell-block" style="flex:2">
          {{ 'bikeshop.print.technician' | translate }}
        </div>
        <div class="cell-block">
          {{ 'bikeshop.print.signature' | translate }}
        </div>
        <div class="cell-block">{{ 'bikeshop.print.date' | translate }}</div>
      </div>
      <div class="block-content">
        <div>
          <span>{{ jobcard.TechnicianDescription }}</span>
        </div>
      </div>
    </div>

    <div class="block">
      <div class="block-title">
        <div class="cell-block" style="flex:3">
          {{ 'bikeshop.print.client_signature' | translate }}
        </div>
        <div class="cell-block">{{ 'bikeshop.print.date' | translate }}</div>
      </div>
      <div class="block-content" style="height:60px;"></div>
    </div>
    <!-- <div style="margin: 32px 16px 16px 16px">
    <b>{{ 'general.jobcard_no' | translate }}:</b> {{ jobcard.JobCardNo }}
  </div> -->
    <div class="qr-container" *ngIf="url && url.length>0 && partnerData.PrintJobcardQRCode">
      <div class="flex-8">{{ 'bikeshop.modal.update_job_card.tab.attachments' | translate }} </div>
      <qrcode [qrdata]="url" colordark="rgba(30, 30, 30, 1)" usesvg="true" [width]="125"></qrcode>
      <!--   [size]="256" [level]="'M'"   -->
    </div>
  </div>


</div>
